import faqs from '@/copy/faq';
import { urlSafe } from '@/utils/string-utils';

const faqRoutes = faqs.map( d => {
	const titleAsPath = urlSafe( d.title );

	return {
		path: `/faq/${titleAsPath}`,
		name: `FAQ: ${d.title}`,
		component: () => import( /* webpackChunkName: "faqEntry" */ '../views/FAQEntry' ),
	};
} );

export default [
	{
		path: '/faq',
		name: 'FAQs',
		component: () => import( /* webpackChunkName: "faq" */ '../views/FAQ.vue' ),
	},

	...faqRoutes,
];
